module.exports = __webpack_public_path__ + "img/icon-coin.a2eef8bc.png";